var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style5"
  }, ".a{fill:#fff}.b{fill:#e4e4e4}.c{fill:#1394e5}#Layer_1{width:48px;margin:auto}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotateSquare",
    transform: "scale(1.0909)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 22,
    cy: 22,
    r: 22,
    id: "circle8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22 10a12 12 0 1 1-12 12 12 12 0 0 1 12-12m0-2a14 14 0 1 0 14 14A14 14 0 0 0 22 8z",
    id: "path10",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22 8v2a12 12 0 0 1 12 12h2A14 14 0 0 0 22 8z",
    id: "path12",
    fill: "#1394e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.5df2ba699fadda4b5431d33595ccf065.svg";
export { ForwardRef as ReactComponent };